import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import Button from '../components/shared/Button'
import logoSvg from '../assets/logo.svg'
import './NotFound.css'

export default function NotFound() {
  const error = useRouteError()

  let title = 'Page Not Found'
  let message = "We couldn't find the page you were looking for."

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page Not Found'
      message = "We couldn't find the page you were looking for."
    } else if (error.status === 500) {
      title = 'Something Went Wrong'
      message = "We're having trouble right now. Please try again."
    } else {
      title = `Error ${error.status}`
      message = error.statusText || 'An unexpected error occurred.'
    }
  }

  return (
    <div className="not-found-page">
      <Link to="/" className="not-found-logo">
        <img src={logoSvg} alt="PlanScan" />
      </Link>

      <div className="not-found-content">
        <div className="not-found-code">404</div>
        <h1 className="not-found-title">{title}</h1>
        <p className="not-found-message">{message}</p>

        <div className="not-found-actions">
          <Link to="/">
            <Button variant="primary" size="large">
              Go to Home Page
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="secondary" size="large">
              Sign In
            </Button>
          </Link>
        </div>
      </div>

      <p className="not-found-help">
        Need help?{' '}
        <a href="mailto:support@planscan.io" className="not-found-link">
          Contact Support
        </a>
      </p>
    </div>
  )
}
